import { NullableSettingConfig } from "./NullableSettingConfig";

export const NullableStringSetting: NullableSettingConfig<string | null> = {
  type: "string",
  serialize: (value: string | null): string | null => {
    return value;
  },

  deserialize: (value: string | null): string | null => {
    return value;
  },
};
